import {useSelector,useDispatch} from 'react-redux'
import {
	deleteCalendarEvent,
	getAllEventsInRange,
	setCreator,
	setEditor,
	setViewer,
	selectors
} from './slice'

export const useEvents = ()=>{
	const dispatch = useDispatch()
	const {status} = useSelector(state=>state.gymCalendar)
	const events = useSelector(selectors.selectAll)

	if (status==='init') dispatch(getAllEventsInRange())

	return {status,events}
}

export const useDeleteEvent = ()=>{
	const dispatch = useDispatch()
	return (payload)=>{
		if (!window.confirm('Are you sure you want to delete this event?')) return 
		return dispatch(deleteCalendarEvent(payload))
	}
}


export const useCreator = () => useSelector(state=>state.gymCalendar.creator)

export const useSetCreator = ()=>{
	const dispatch = useDispatch()
	return payload => dispatch(setCreator(payload))
}

export const useEditor = ()=>{
	const {show,id,editSeries,date} = useSelector(state=>state.gymCalendar.editor)
	const event = useSelector(
		state => Boolean(id) && selectors.selectById(state,id)
	)
	//if we select edit entire series on an exception 
	//we need to return the parent and not the exception
	const targetEvent = (
		editSeries && parseInt(event.event_pid) > 0
		? event.parent
		: event
	)
	return {show,event:targetEvent,editSeries,date}
}

export const useViewer = ()=>{
	const {show,id} = useSelector(state=>state.gymCalendar.viewer)
	const event = useSelector(
		state => Boolean(id) && selectors.selectById(state,id)
	)
	return {show,event}
}

export const useSetEditor = ()=>{
	const dispatch = useDispatch()
	return payload => dispatch(setEditor(payload))
}

export const useSetViewer = ()=>{
	const dispatch = useDispatch()
	return payload => dispatch(setViewer(payload))
}

